
import {EN} from '../helpers/GlobalsHelper';

const openInputLabelTooltip = function() {

	document.addEventListener( 'click', ( ev ) => {
		if ( ev.target && ev.target.closest( '.js-input_row_tooltip' ) ) {
			ev.preventDefault();
		}
	} );

	document.addEventListener( 'click', ( ev ) => {
		if ( ev.target && ev.target.closest( '.js-input_row_tooltip_box_close' ) ) {
			ev.preventDefault();
			const container = ev.target.closest( '.input_row_tooltip_container' );
			if ( container ) {
				container.classList.remove( 'open' );
			}
		}
	} );

	document.addEventListener( 'click', ( ev ) => {
		if ( ev.target && ev.target.closest( '.input_row_tooltip_container' ) ) {
			const container = document.querySelector( '.input_row_tooltip_container' );
			if ( container ) {
				container.classList.remove( 'open' );
			}
		}
	} );

	if ( EN.Supports.touch() ) {
		document.addEventListener( 'click', ( ev ) => {
			if ( ev.target && ev.target.closest( '.js-input_row_tooltip' ) ) {
				ev.preventDefault();
				const container = ev.target.closest( '.input_row_tooltip_container' );
				if ( container ) {
					container.classList.toggle( 'open' );
				}
			}
		} );
	}
};

export { openInputLabelTooltip };
